module.exports = __webpack_public_path__ + "img/162.4429a725.png";